module.exports = __webpack_public_path__ + "static/kaffee2-85994d6a1f086a056713e1e267e8aedc.jpg";